import { isNumber } from 'lodash';
import type { UseQueryOptions } from 'react-query';

import { toast } from '@hivebrite/design-system/Toast';

import { useApi } from 'hb-builder/api';
import type { UserBannerDataResponse } from 'hb-builder/api/userBanner/types';
import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance } from 'hb-react/shared/utils/axios';

const QUERY_KEY = 'dynamic_search_user_banner';

export const useGetUserInUserBanner = ({
  enabled = true,
  onError,
  onSuccess,
}: Pick<UseQueryOptions, 'enabled' | 'onError' | 'onSuccess'> = {}) => {
  const { authenticationIds } = useApi();
  const { network: networkId, user: userId } = authenticationIds;

  const queryFn = async () => {
    if (!isNumber(userId)) return;
    const { data } = await axiosInstance.get<{
      user?: UserBannerDataResponse;
    }>(Routes.preview_user_user_path(networkId, userId), {
      params: authenticationIds,
    });

    return data?.user;
  };

  return useQueryOnce<UserBannerDataResponse | undefined>(
    [QUERY_KEY, networkId, userId],
    queryFn,
    {
      enabled: isNumber(networkId) && isNumber(userId) && enabled,
      onError: (error) => {
        toast.error(__('Sorry, an error occurred'));
        onError?.(error);
      },
      onSuccess,
    },
  );
};
